module.exports = __webpack_public_path__ + "img/Nordstrom_right.908049de.jpg";